/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { Pagination } from "react-bootstrap";
import { ProgressBar } from "react-bootstrap";
import { Grid, Button } from "@material-ui/core";
import { Modal } from "react-bootstrap";

import { getMyLicenseList, insertReq } from "../../api";
import LayoutAuth from "./Layout";
export function BuyLicense(props) {
  console.log("BuyLicense", props);
  const [loading, setLoading] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [licenseList, setLicenseList] = useState([]);
  const [input, setInput] = useState([]);
  const [myLicenseList, setMyLicenseList] = useState([]);
  const [req, setReq] = useState();
  const history = useHistory();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getMyLicenseList();
        console.log("result", result);
        setMyLicenseList(result.data);
      } catch (e) {
        console.log(e);
        // Handle error
      }
    };
    fetchData();
  }, []);

  const toggleShow = () => {
    setIsShow(!isShow);
  };

  const selectLicense = (value) => {
    var index = input.indexOf(value);
    if (index === -1) {
      setInput([...input, value]);
    } else {
      input.splice(index, 1);
      setInput([...input]);
    }
  };

  const regReq = async () => {
    toggleShow();

    const param = {
      userNo: localStorage.getItem("userNo"),
      contents: req,
      type: "new",
    };

    const res = await insertReq(param);
    // console.log("resres", res);

    if (res.result) {
      alert("문의가 정상적으로 접수되었습니다.");
      history.push("/licenseList");
    } else {
      alert("문의가 정상적으로 접수되지 않았습니다.");
      return false;
    }
  };

  const goReq = () => {
    if (req === undefined || req.trim() === "") {
      alert("문의 내용을 입력해 주세요.");
      return false;
    }

    toggleShow();
  };

  const doStart = () => {
    if (myLicenseList.length === 0) {
      alert(
        "라이선스 구매 후 시작 가능합니다.\n라이선스 구매 문의하기를 이용해 주세요."
      );
      return false;
    }
    props.login(localStorage.getItem("token"));
    // history.push("/main");
  };

  return (
    <LayoutAuth>
      <div className="card card-custom px-10 py-10" id="pageid19">
        <Modal show={isShow}>
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              문의하기
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            {/* <h1 className="text-primary mb-5">
              <img
                src={toAbsoluteUrl("/media/bg/popup-undo3x.png")}
                width="40"
                height="40"
              />
            </h1> */}
            <span>작성하신 대로 문의하시겠습니까?</span>
          </Modal.Body>
          <Modal.Footer>
            <div>
              <button
                type="button"
                onClick={toggleShow}
                className="btn btn-light btn-elevate"
              >
                취소
              </button>
              <> </>
              <button
                type="button"
                onClick={regReq}
                className="btn btn-primary btn-elevate"
              >
                확인
              </button>
            </div>
          </Modal.Footer>
        </Modal>
        <div className="card-header border-0 align-items-center justify-content-between px-0">
          <h2 className="flex-column">AIMILY Solution</h2>
          <div className="card-toolbar">
            {/* <Link to="/auth/login"> */}
            <button
              style={{ backgroundColor: "white", borderColor: "white" }}
              id="join-success"
              disabled={true}
              className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
              onClick={doStart}
            >
              <span>시작 하기</span>
              {loading && <span className="ml-3 spinner spinner-white"></span>}
            </button>
            {/* </Link> */}
          </div>
        </div>
        <div className="license d-flex flex-center align-items-center justify-content-center mb-4">
          <span>라이선스</span>
        </div>
        <div className="text-right mb-7">
          <Link
            to="/licenseList"
            className="font-size-h6 text-hover-primary mr-3"
            style={{ fontWeight: "500" }}
          >
            라이선스 전체 보기
          </Link>
          <Link
            to="/buyLicense"
            className="font-size-h6 text-hover-primary"
            style={{ fontWeight: "bold" }}
          >
            라이선스 구매 문의하기
          </Link>
        </div>

        {/* <!---- page id 21 ----> */}
        <div className="pageid21">
          <div
            style={{ marginTop: "20px", fontSize: "20px", fontWeight: "bold" }}
          >
            문의 내용
          </div>
          <div style={{ marginTop: "10px", display: "-webkit-box" }}>
            <textarea
              maxlength="1500"
              onChange={(e) => setReq(e.target.value)}
              style={{
                width: "100%",
                height: "300px",
                resize: "none",
                padding: "10px",
              }}
            />
            {req != null ? (
              <span style={{ position: "absolute" }}>{req.length}/1500</span>
            ) : (
              <span style={{ position: "absolute" }}>0/1500</span>
            )}
          </div>
          <div style={{ display: "block", textAlign: "right" }}>
            <span style={{ fontSize: "15px", fontWeight: "bold" }}>
              담당자가 확인 후 연락 드립니다.
            </span>
          </div>
          <div className="text-right mt-5">
            <button
              onClick={() => goReq()}
              className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
            >
              <span>문의하기</span>
              {loading && <span className="ml-3 spinner spinner-white"></span>}
            </button>
          </div>
        </div>

        {/* <!---- page id 21 ----> */}
      </div>
    </LayoutAuth>
  );
}
export default BuyLicense;
